import { ApiCallError } from 'app/http/ApiCallError';

const getBodyMessage = (body: unknown): string | undefined => {
  if (typeof body === 'object' && body !== null && 'message' in body && typeof body.message === 'string') {
    return body.message;
  }
  return undefined;
};

export const getApiErrorMessage = (error: unknown): string => {
  if (error === null || error === undefined) {
    return '';
  }
  if (error instanceof ApiCallError) {
    return getBodyMessage(error.body) ?? error.message;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return String(error);
};
